(function() {
  var toggleFront = {
    toggleContentVisible : ['tooltip-item__active', 'tooltip-visible'],

    clickShowHide : function(event) {
      var that = $(this);
      $.each(toggleFront.toggleContentVisible, function(i, v) {
        $('.x-toggle-item').not(that.parent()).removeClass(v);
      });
      $(this).parent().toggleClass($(this).data('classToggle'));
    },

    clickBody : function(event) {
      var target = $(event.target);
      var parentElements = target.parents();
      var isContentToggle = false;
      var toggleContentElements = $('.x-toggle-content').get();
      var isToggleTrigger = false;
      var toggleTriggerElements = $('.x-toggle-trigger').get();

      $.each(toggleContentElements, function(i, v) {
        if ($.inArray(v, parentElements) !== -1) {
          isContentToggle = true;
          return false;
        }
      });

      if (isContentToggle) return false;

      $.each(toggleTriggerElements, function(i, v) {
        if ($.inArray(v, parentElements) !== -1) {
          isToggleTrigger = true;
          return false;
        }
      });

      if (isToggleTrigger) return false;

      if (!target.is('.x-toggle-content') && !target.is('.x-toggle-trigger')) {
        var toggleItems = $('.x-toggle-item');
        $.each(toggleFront.toggleContentVisible, function(i, v) {
           toggleItems.removeClass(v);
        });
      }
    }
  }

  $(document).ready(function() {
    if ($('.x-toggle-trigger').length > 0) {
      $('body').on('click', '.x-toggle-trigger', toggleFront.clickShowHide);
      $('body').on('click', toggleFront.clickBody);
    }
  });
})();
